/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { SnackbarProvider, Button, withSnackbar } from 'notistack'
import { history } from './helpers'
import * as actions from './store/actions'
import AOS from 'aos';
import 'aos/dist/aos.css';

import './App.css'

import Pages from './pages'

class App extends React.Component {
  constructor(props) {
    super(props)
    history.listen((location, action) => {
      this.props.clear()
    })
    AOS.init();

  }

  generate(alert) {
    this.props.enqueueSnackbar(alert.message, {
      variant: alert.type,
      autoHideDuration: 5000,
      onClose: () => this.props.clear(),
    })
  }

  render() {
    const { alert } = this.props

    if (alert.message) {
      this.generate(alert)
    }

    return (
      <div className="main">

        <Pages />

      </div>
    )
  }
}

function mapStateToProps(state) {
  const { alert,loginned } = state
  return {
    alert,loginned
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clear: (text) => dispatch(actions.alert.clear(text)),
  }
}

const connectedApp = connect(mapStateToProps, mapDispatchToProps)(App)

const notistackRef = React.createRef()
const onClickDismiss = key => () => {
  notistackRef.current.closeSnackbar(key)
}

App.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
}

const AppWithSnackbar = withSnackbar(connectedApp)

function IntegrationNotistack() {
  return (
    <SnackbarProvider
      ref={notistackRef}
    >
      <AppWithSnackbar />
      
    </SnackbarProvider>
  )
}

export { IntegrationNotistack as App }
